<div class="not-found-background">
  <div class="columns">
    <div class="column" style="padding: 25% 0 5% 0;color: white">
      <div class="columns">
        <div class="column is-one-quarter"></div>
        <div class="column">
          <div class="title is-2" style="color: white;font-family: 'Open Sans', sans-serif">Leider kann die Seite nicht aufgerufen werden</div>
          <div class="title is-5" style="color: white;font-family: 'Open Sans', sans-serif">Versuchen Sie es bitte später nochmal oder kontaktieren Sie uns!</div>
          <div class="columns">
            <div class="column is-one-third">
              <div class="button is-blue" (click)="setShowContactForm()">Kontaktformular</div>
            </div>
            <div class="column is-one-third">
              <div class="button is-blue" (click)="reload()">Seite neu laden</div>
            </div>
          </div>
        </div>
        <div class="column is-one-quarter"></div>
      </div>
    </div>
  </div>
</div>

<app-contact-overlay [displayed]="showContactForm" (modalClosed)="showContactForm = false"></app-contact-overlay>

